import { useIntl } from "react-intl";

import { IconSpinner } from "@/components/Icons";

export type CircularProgressProps = { size: number };

export function CircularProgress({ size }: CircularProgressProps) {
  const intl = useIntl();
  return (
    <span role="status">
      <IconSpinner
        className="animate-spin"
        style={{ width: `${size}px`, height: `${size}px` }}
      />
      <span className="sr-only">
        {intl.formatMessage({
          defaultMessage: "Loading",
          description: "Circular progress accessibility label",
        })}
      </span>
    </span>
  );
}
